import styled from 'styled-components';
export const NumberPickerStyled = styled.div`
  width: calc(var(--px) * 150);
  display: flex;
  justify-content: space-between;

  .scorepicker-button {
    width: var(--midButtonHeight);
    height: var(--midButtonHeight);
    touch-action: manipulation;

    span {
      color: white !important;
    }

    svg {
      font-size: calc(var(--px) * 32);
    }
  }

  .material-input.override {
    margin-top: 0;
    width: 2.75em;
    padding: 0;

    input {
      font-size: calc(var(--px) * 30);
      text-align: center;
    }
  }

  p {
    display: none;
  }
`;
